enum EFormType {
	Standard,
	Parameter,
	View,
	ApproveList,
	Metadata,
	Template,
	Action
}

export default EFormType;
